import { z } from 'zod';
import { IsoDateTime } from './common.js';
import { ModuleCode } from './modules.js';
/**
 * Assistant de configuration (ADR-022, D-H46, phase H7) : liste de mise en
 * route **calculée** sur les données réelles du tenant, adaptée à ses modules.
 * Seuls « ignoré » et « masqué » sont stockés (R-ONB-01, R-ONB-02).
 */
export const OnboardingStepCode = z.enum([
    'identity',
    'legal',
    'branding',
    'property',
    'taxes',
    'billing',
    'resources',
    'ratePlans',
    'compliance',
    'outlets',
    'catalog',
    'printing',
    'users',
]);
export const OnboardingStepGroup = z.enum(['identity', 'property', 'sales', 'team']);
export const OnboardingStepStatus = z.enum(['DONE', 'TODO', 'SKIPPED']);
export const OnboardingStep = z.object({
    code: OnboardingStepCode,
    group: OnboardingStepGroup,
    status: OnboardingStepStatus,
    /** Le Owner peut la marquer « ignorée » (pas de taxe, pas d'imprimante…). */
    skippable: z.boolean(),
    /** Module qui rend l'étape pertinente ; `null` = toujours. */
    module: ModuleCode.nullable(),
    /** Écran (et onglet) où réaliser l'étape. */
    href: z.string(),
    /** Nombre d'éléments trouvés quand l'étape se mesure (ressources, tarifs…). */
    count: z.number().int().nonnegative().nullable(),
});
export const OnboardingStatus = z.object({
    steps: z.array(OnboardingStep),
    /** Étapes faites ou ignorées. */
    done: z.number().int().nonnegative(),
    total: z.number().int().nonnegative(),
    complete: z.boolean(),
    dismissedAt: IsoDateTime.nullable(),
    /** Vrai tant que l'assistant a quelque chose à montrer et n'est pas masqué. */
    visible: z.boolean(),
});
export const UpdateOnboardingRequest = z.object({
    skip: z.array(OnboardingStepCode).optional(),
    unskip: z.array(OnboardingStepCode).optional(),
    dismissed: z.boolean().optional(),
});
//# sourceMappingURL=onboarding.js.map